import { openEscalationWithEmailPopup } from '../components/popups/EscalateWithEmailPopup/EscalateWithEmailPopup';
import { openEscalationPopup } from '../components/popups/EscalatePopup/EscalatePopup';
import { openEscalationToSpecialistsPopup } from '../components/popups/EscalateToSpecialistsPopup/EscalateToSpecialistsPopup';
import { ESCALATE_TO_SMB_WITH_EMAIL } from '../constants/conversationTypes';
import * as selectors from '../extractFromState';
import { trackEscalateButtonClick } from '../analytics/buttonEventAnalytics';
import { escalateCurrentTicket, hideConversation } from './index';

export const handleEscalationPopup = (ticket, escalationReason = null, escalateToBusinessAsExpert = false) => {
  return async (dispatch, getState) => {
    const state = getState();
    const isAdmin = selectors.isSpecialist(state);
    trackEscalateButtonClick();
    const { ticketType, customerEmail } = ticket || {};
    const escalateToBusiness = isAdmin || escalateToBusinessAsExpert;
    if (escalateToBusiness) {
      if (ESCALATE_TO_SMB_WITH_EMAIL.includes(ticketType) && !customerEmail) {
        // eslint-disable-next-line
        return openEscalationWithEmailPopup(escalationReason, ({ escalateMessage }) => {
          const modifiedEscalationMessage = `Escalation Reason: ${escalateMessage}`;

          return dispatch(escalateCurrentTicket(modifiedEscalationMessage, { escalateToBusinessAsExpert }, ticket));
        });
      }

      return openEscalationPopup(
        isAdmin,
        escalationReason,
        ({ escalateMessage, reasonSelection }) => {
          const modifiedEscalationMessage = `Escalation Reason: ${reasonSelection} ${
            escalateMessage ? `- ${escalateMessage}` : ''
          }`;
          const customerEmailArgument = ticket.customerEmail;

          return dispatch(
            escalateCurrentTicket(
              modifiedEscalationMessage,
              { customerEmail: customerEmailArgument, escalateToBusinessAsExpert },
              ticket
            )
          );
        },
        escalateToBusinessAsExpert
      );
    }

    return openEscalationToSpecialistsPopup(escalationReason, ({ customMessage, reasonSelection }) => {
      if (ticket.isTestTicket) {
        return dispatch(hideConversation(ticket.ticketId));
      }
      const modifiedEscalationMessage = `Escalation Reason: ${reasonSelection} ${
        customMessage ? `- ${customMessage}` : ''
      }`;

      return dispatch(escalateCurrentTicket(modifiedEscalationMessage, { reasonSelection, customMessage }, ticket));
    });
  };
};
